export const arrayOfStringsToUpperCase = array => array.map(el => el.toUpperCase());
